var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

const React = require('react');
const Icon = require('@infotech/uikit-icon').default;

function Svg(props) {
  const svgProps = Object.assign({}, props);
  const title = props.title;
  delete props.title;

  /* <svg {...svgProps} ><title>{title}<title>...</svg> */
  return React.createElement(
    'svg',
    _extends({ width: '24', height: '24', viewBox: '0 0 24 24', focusable: 'false' }, svgProps, { 'aria-labelledby': 'title' }),
    React.createElement(
      'title',
      { id: 'title' },
      title
    ),
    React.createElement('rect', { stroke: '#000', fill: '#FFF', x: '4.5', y: '4.5', width: '15', height: '15', rx: '7.5', strokeOpacity: '.32', fillRule: 'evenodd', role: 'presentation' })
  );
}

module.exports = function unchecked(props) {
  return React.createElement(Icon, _extends({ glyph: Svg }, props));
};